const i18nConfig = {
    locales: ['en', 'fr', 'ar', 'de', 'es', 'it', 'ru'],
    defaultLocale: 'en'
  };
  
  module.exports = i18nConfig;